import { render } from "./Footer.vue?vue&type=template&id=22fe208c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=22fe208c&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-22fe208c"

export default script